import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SeSideSnackbarStateService } from '../services/se-side-snackbar-state.service';
export type SideSnackbarType = 'info' | 'warning' | 'error';

@Component({
    selector: 'se-side-snackbar',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './se-side-snackbar.component.html',
    styleUrl: './se-side-snackbar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeSideSnackbarComponent {
    constructor(public state: SeSideSnackbarStateService) { }

    get icon(): string {
        switch (this.state.type()) {
            case 'error': return 'error';
            case 'warning': return 'warning';
            default: return 'info';
        }
    }
}
